import { render, staticRenderFns } from "./CardContent.vue?vue&type=template&id=9c6a85c6&scoped=true&"
import script from "./CardContent.vue?vue&type=script&lang=js&"
export * from "./CardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6a85c6",
  null
  
)

export default component.exports